const dict = {
  chooseLang: "Scegli lingua",
  agree: "Accetto",

  //Licence
  instructions: "Istruzioni",
  step1: "Passo 1: Scansiona il codice QR",
  locateqr: "Individua il codice QR sulla tua destra.",
  useSmartphone:
    "Usa la fotocamera del tuo smartphone o un'app di scansione QR per scansionarlo. Questo ti porterà al passo successivo.",
  step2: "Passo 2: Inserisci le informazioni della playlist",
  afterScan: "Dopo aver scansionato il codice QR, ti verrà chiesto di inserire le informazioni della tua playlist.",
  makeSure: "Assicurati di compilare tutti i campi obbligatori.",
  step3: "Passo 3: Torna all'app",
  onceYou:
    "Una volta inseriti i dettagli della playlist, puoi tornare all'app e continuare la tua esperienza.",
  refresh: "AGGIORNA",
  playlist: "Playlist",
  bigPlaylist: "PLAYLIST",
  noLicence: "Non hai una licenza.",
  scanLicence: "Scansiona per acquistare la licenza.",
  noPlaylist: "Non hai nessuna playlist",
  privacyBig: "MODALITÀ PRIVACY",
  scanToAddBig: "SCANSIONA PER AGGIUNGERE PLAYLIST",
  scanToBuyBig: "SCANSIONA PER ACQUISTARE LICENZA",
  orVisit: "o visita",
  andenterdeviceID: "e inserisci questo ID dispositivo:",
  removePlaylist: "Rimuovi playlist",
  wantToRemove: "Vuoi rimuovere?",
  cancelBig: "ANNULLA",
  loading: "Caricamento...",
  enablePMode: "Attiva la Modalità Privacy per continuare a guardare.",
  killSwitchProtecting: "Il Kill Switch protegge la tua privacy bloccando l'accesso quando la Modalità Privacy è disattivata.",
  kSwitchProtecionActive: "Protezione Kill Switch Attiva",
  privacyMode: "Modalità Privacy",
  ok: "OK",

  //Home
  bigLiveTv: "TV in Diretta",
  bigMovies: "Film",
  bigSeries: "Serie",
  //Channel-Menu
  noChannels: "Questa playlist non ha dati sui canali",
  searchChannels: "Cerca canale",
  tapToPlay: "Tocca per riprodurre lo stream video.",
  categoryEmpty: "Questa categoria è vuota",
  pinNotSet: "PIN non impostato",
  setPinNow: " Vuoi impostare il tuo PIN adesso?",
  preview: "ANTEPRIMA",
  liveTv: "TV in Diretta",
  addToFav: "Aggiungi ai Preferiti",
  removeFromFav: "Rimuovi dai Preferiti",
  now: "Ora:",
  nextPlaying: "Prossimo:",
  channels: "Canali",
  noChannelsFound: "Nessun canale trovato",

  //Movies
  noMovies: "Questa playlist non ha dati sui film",
  searchMovies: "Cerca film",
  noFavMovies: "Nessun film preferito",
  //series
  noSeries: "Questa playlist non ha dati sulle serie",
  searchSeries: "Cerca serie",
  noFavSeries: "Nessuna serie preferita",
  search: " Cerca",
  thereIsProblem: "Al momento c'è un problema",
  tryAgainLater: "Riprova più tardi.",
  series: "Serie",
  movies: "Film",
  noSeriesFound: "Nessuna serie trovata",
  noMoviesFound: "Nessun film trovato",
  //entity
  play: "RIPRODUCI",
  playMovie: "Riproduci film",
  recommendations: "Consigli",
  //User Info
  userInfo: "Informazioni utente",
  aboutApp: "Informazioni sull'app",
  //Userinfo
  account: "Account",
  subscriptions: "Abbonamenti",
  privacyPilicy: "Privacy e Policy",
  languge: "Lingua",
  english: "Inglese",
  italian: "Italiano",
  german: "Tedesco",
  spanish: "Spagnolo",
  french: "Francese",
  saudiArabia: "Arabo",
  chinese: "Cinese",
  greek: "Greco",
  turkish: "Turco",
  change_pin: "Cambia PIN",
  kill_switch: "Kill Switch",
  device_info: "Informazioni dispositivo",
  unknown: "Sconosciuto",

  //headers
  settings: "Impostazioni",
  termsConditions: "Termini e Condizioni",
  home: "Home",

  //license
  scanQrCode: "Scansiona il codice QR per inviare una playlist",
  managePlaylist: "Gestisci playlist",
  orVisitt: "O visita",
  scanToAdd: "Scansiona per aggiungere una playlist o visita",

  //device info
  display: "Display",
  storage: "Archiviazione",
  network: "Rete",
  connection: "Connessione",
  macAddress: "Indirizzo MAC:",
  deviceId: "ID dispositivo:",
  pmInfo: "Informazioni sulla Modalità Privacy",
  statusActive: "Stato: Attivo",
  underMaintance: "Stato: In manutenzione",
  version: "Versione:",
  lastBuildDate: "Data ultima build:",
  lastUpdated: "Ultimo aggiornamento: ",

  //kill switch
  enableKillSwitch: "Abilitare il Kill Switch?",
  disableKillSwitch: "Disabilitare il Kill Switch?",
  whenEnabled: "Se abilitato, OrbixPlay funzionerà SOLO quando la Modalità Privacy è attiva.",
  withOrWithoutPM: "OrbixPlay funzionerà normalmente con o senza la Modalità Privacy.",
  extra_privacy_protection: " Protezione Privacy Aggiuntiva",
  pmOn: "• Se la Modalità Privacy è ATTIVA: puoi trasmettere contenuti in sicurezza",
  killSwitchDescription: "Il Kill Switch fornisce un ulteriore livello di protezione per la massima privacy.",
  pmOff: "• Se la Modalità Privacy è DISATTIVA: l'app bloccherà l'accesso per proteggere la tua privacy",
  reenable: "Puoi riabilitarlo in qualsiasi momento per la massima sicurezza.",
  cancel: "Annulla",
  enable: "Abilita",
  disable: "Disabilita",
  killSwitch: "Kill Switch – Protezione Privacy Aggiuntiva",
  ipHidden: "Quando attivi la Modalità Privacy, il tuo indirizzo IP viene nascosto e la tua connessione passa attraverso un sistema sicuro — simile al funzionamento di una VPN.",
  extraLayer: "Il Kill Switch è un ulteriore livello di protezione: se lo abiliti, OrbixPlay funzionerà solo quando la Modalità Privacy è attiva.",
  ifPmOn: "• Se la Modalità Privacy è ATTIVA: puoi trasmettere contenuti in sicurezza",
  ifPmOff: "• Se la Modalità Privacy è DISATTIVA: l'app bloccherà l'accesso per proteggere la tua privacy",
  recommended: "Consigliato per chiunque voglia la massima sicurezza e non voglia mai trasmettere senza protezione.",
  current_status: "Stato attuale:",
  pressToDisable: "🛡️ ABILITATO - Premi per disabilitare",
  pressToEnable: "○ DISABILITATO - Premi per abilitare",
  pressEnter: " Premi Invio sul pulsante in alto per modificare l'impostazione del Kill Switch",

  //set pin
  pinSetSuccessfully: "PIN impostato con successo!",
  createPin: "Crea il tuo PIN",
  confirmPin: "Conferma il tuo PIN",
  confirmYourPin: "confirmPin: 'Conferma il tuo PIN'",
  initializingPin: "Inizializzazione configurazione PIN...",
  enterCurrentPin: "Inserisci il PIN attuale",
  enterNewPin: "Inserisci il nuovo PIN",
  confirmNewPin: "Conferma il nuovo PIN",
  pinChanged: "PIN modificato con successo!",
  pinHasChanged: " Il tuo PIN è stato modificato con successo!",

  //lastones
  playInfo: "Informazioni playlist",
  playName: "Nome playlist:",
  host: "Host:",
  username: "Nome utente:",
  password: "Password:",
  packName: "Nome pacchetto:",
  expireDate: "Data di scadenza:",

  //privacyPolicy
  one: "1. Disclaimer sui contenuti: OrbixPlay è una piattaforma progettata per migliorare la tua esperienza digitale. Tuttavia, è importante notare che OrbixPlay non ospita, fornisce o distribuisce contenuti video. Il nostro servizio è strutturato per supportare il tuo percorso digitale, ma non ci assumiamo responsabilità per la disponibilità, la qualità o il contenuto del materiale video, in quanto ciò esula dall'ambito dei nostri servizi.",
  two: "2. Nessuna responsabilità per contenuti di terze parti: OrbixPlay LLC non è responsabile per eventuali contenuti di terze parti a cui potresti accedere tramite la nostra applicazione. Il tuo coinvolgimento con qualsiasi contenuto esterno, inclusa la sua legalità, affidabilità o idoneità, è interamente a tuo rischio.",
  three:
    "3. Giurisdizione e Conformità: OrbixPlay LLC opera sotto la giurisdizione degli Stati Uniti. Gli utenti sono responsabili di garantire che il loro utilizzo dell'applicazione sia conforme a tutte le leggi locali, statali e federali.",
  four: "4. Politica dei prezzi: I prezzi per i servizi di OrbixPlay sono soggetti a modifiche in qualsiasi momento senza preavviso. Accettando questo accordo, riconosci e accetti che i prezzi possono variare e che tali modifiche non influenzeranno il tuo servizio attuale fino al rinnovo dell'abbonamento.",
  five: `5. Nessuna garanzia: L'applicazione OrbixPlay e i suoi servizi sono forniti "così come sono" senza garanzie esplicite o implicite, incluse, a titolo esemplificativo, le garanzie implicite di commerciabilità, idoneità per uno scopo specifico e non violazione.`,
  six: "6. Accettazione dei Termini: Facendo clic su Accetta, accetti di essere vincolato dai termini di questo disclaimer e riconosci che qualsiasi violazione potrebbe comportare la cessazione dell'accesso ai servizi OrbixPlay.",
  orbixUserAgreement: "ACCORDO UTENTE E DISCLAIMER ORBIXPLAY",
  beforeyouProcc: "Prima di procedere, si prega di leggere e accettare i seguenti termini e condizioni:",

  //additional
  exitApp: "Esci da OrbixPlay",
  wantToExit: "Sei sicuro di voler uscire da OrbixPlay?",
  Resume: "Riprendi",

  whatsnewinv: "Novità nella versione v",
  whatsnew: "Novità",

  resellerInfiniteDevices: "Piano Rivenditore: Dispositivi Illimitati",
  resellerInfiniteDevicesDesc: "La stessa playlist può ora essere installata su dispositivi illimitati — non 5, non 10, ma quanti ne desideri.",
  thankyouforusingorbixplayenjoythenewfeatures: "Grazie per aver scelto OrbixPlay — goditi le nuove funzionalità!",

  instanthomescreen: "Continua a guardare",
  instanthomescreendesc: "Riprendi le tue serie e film esattamente da dove li hai lasciati.",
  turbomoviesearch: "Funzione Preferiti",
  turbomoviesearchdesc: "Salva i tuoi contenuti preferiti per un accesso rapido e facile in qualsiasi momento.",
  lighterondataandbattery: "Stabilità del lettore migliorata",
  lighterondataandbatterydesc: "Maggiore affidabilità di riproduzione e operazioni di ricerca più fluide.",
  underthehoodfixes: "Correzioni in background",
  underthehoodfixesdesc: "Varie correzioni di bug e miglioramenti delle prestazioni per una migliore esperienza.",

  proxyMaintenance: 'Manutenzione proxy',
  proxyMaintenanceMessage: 'Il server proxy è attualmente in manutenzione. Riprova più tardi.',

  playlistInformation: 'Informazioni playlist',
  playlistExpDate: 'Data di scadenza playlist: ',
  select_playlist: "Seleziona Playlist",
  choose_playlist: "Scegli una playlist per iniziare a guardare",
  invalid_line: "Linea Non Valida",
  expire_date: "Data di Scadenza:",
  expired: "Scaduto",
  waiting_connection: "In attesa di connessione...",
  reconnection_attempt: "Tentativo di riconnessione",
  try_again: "Riprova",
  go_back: "Torna Indietro",
  unable_to_resume: "Impossibile Riprendere",
  reconnecting: "Riconnessione in corso...",
  no_internet_connection: "Nessuna Connessione Internet",
  please_try_again: "Impossibile riavviare lo stream. Riprova.",
  restore_stream: "Attendi mentre ripristiniamo il tuo stream.",
  reconnect_automatically: "Controlla la rete e ci riconnetteremo automaticamente.",
  check_wifi: "Controlla la tua connessione WiFi",
  check_ethernet: "Controlla la tua connessione Ethernet / LAN",
  check_internet: "Controlla la tua connessione internet",

  //add playlist screen
  add_playlist_screen: "Aggiungi Playlist",
  add_playlist: "Aggiungi playlist manualmente",
  playlist_name_required: "Il nome della playlist è obbligatorio",
  m3u_url_required: "L'URL M3U della playlist è obbligatorio",
  server_url_required: "L'URL del server è obbligatorio",
  username_required: "Il nome utente è obbligatorio",
  password_required: "La password è obbligatoria",
  orbix_code_required: "Il codice host Orbix è obbligatorio",
  list_code_required: "Il codice lista è obbligatorio",
  device_id_required: "L'ID dispositivo è obbligatorio",
  device_id: "ID dispositivo : ",
  playlist_format: "Formato Playlist",
  m3u: "URL M3U",
  username_password: "Nome utente / Password",
  orbix_code: "Codice Orbix",
  list_code: "Codice Lista",
  playListName: "Nome Playlist *",
  m3uUrl: "URL Playlist M3U *",
  server_URL: "URL Server *",
  username_req: "Nome utente *",
  password_req: "Password *",
  orbix_code_req: "Codice Host Orbix *",
  list_code_req: "Codice Lista *",
  addPlaylist: "Aggiungi Playlist",
  adding: "Aggiunta in corso...",
  my_playlist: "La Mia Playlist",
  username_placeholder: "nome utente",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Estensione flusso",

  //storage_and_data
  storage_and_data: "Archiviazione e Dati",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Inserisci il PIN parental",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Stato",
  active: "Attivo",
  expiration: "Scadenza",
  max_connections: "Connessioni max",
  one_device: "1 Dispositivo",
  created: "Creato",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Archiviazione e Dati",
  section_subtitle: "Gestisci i dati memorizzati dall'app",
  favourites_label: "Preferiti",
  history_label: "Cronologia",
  cleared_label: "Eliminato",
  all_cleared_label: "Tutto eliminato",
  remove_cancel_label: "Annulla",
  remove_confirm_label: "Elimina",
  clear_fav_channels_title: "Canali preferiti",
  clear_fav_channels_subtitle: "Rimuovi tutti i canali salvati",
  clear_fav_channels_message: "Cancellare tutti i canali preferiti?",
  clear_fav_movies_title: "Film preferiti",
  clear_fav_movies_subtitle: "Rimuovi tutti i film salvati",
  clear_fav_movies_message: "Cancellare tutti i film preferiti?",
  clear_fav_series_title: "Serie preferite",
  clear_fav_series_subtitle: "Rimuovi tutte le serie salvate",
  clear_fav_series_message: "Cancellare tutte le serie preferite?",
  clear_continue_watching_movies_title: "Continua a guardare – Film",
  clear_continue_watching_movies_subtitle: "Rimuovi avanzamento film",
  clear_continue_watching_series_title: "Continua a guardare – Serie",
  clear_continue_watching_series_subtitle: "Rimuovi avanzamento serie",
  clear_continue_watching_title: "Continua a guardare",
  clear_continue_watching_message: "Cancellare la cronologia di visione?",
  clear_all_title: "Cancella tutti i dati",
  clear_all_message: "Questo cancellerà tutti i preferiti e la cronologia.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Scegli come vengono richiesti i flussi live dal server.",
  ts_desc: "Flusso MPEG-TS standard",
  m3u8_desc: "Flusso HLS adattivo",
  current: "Corrente",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Accesso limitato",
  to_access_playlists: "Per accedere alle playlist:",
  enable_privacy_mode_step: "1. Attiva la Modalità Privacy dalla schermata principale",
  disable_kill_switch_step: "2. Oppure disattiva il Kill Switch in Impostazioni → Kill Switch",
  preparingContent: "Preparazione dei contenuti",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Caricamento",
  live_now: "ORA IN DIRETTA",
  news: "NOTIZIE",
  sport: "SPORT",
  kids: "BAMBINI",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Episodio",
  no_episodes: "Non ci sono episodi disponibili per questa stagione.",

  searchForChannels: "Cerca canali...",
  kbSpace: "Spazio",
  kbCaps: "Maiuscolo",
  pressOkToPlay: "Premi OK per riprodurre",
  live: "In diretta",
};

export default dict;